import getAllAttachmentIds from '../utils/getAllAttachmentIds';
import { ComposeViewState } from 'owa-mail-compose-store';
import { lazyGetAttachment } from 'owa-attachment-model-store';
import { getAccessIssuesForAttachments, getInfoBarId } from 'owa-attachment-policy';
import addInfoBarMessage from 'owa-info-bar/lib/actions/addInfoBarMessage';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';

export default async function loadAttachmentPolicyInfoBars(composeViewState: ComposeViewState) {
    const composeAttachments = await getAllAttachments(composeViewState);
    const infoBarIds = getAccessIssuesForAttachments(composeAttachments).map(getInfoBarId);
    infoBarIds.forEach(id => addInfoBarMessage(composeViewState, id));
}

async function getAllAttachments(composeViewState: ComposeViewState): Promise<AttachmentType[]> {
    const getAttachment = await lazyGetAttachment.import();
    return getAllAttachmentIds(composeViewState).map(a => getAttachment(a).model);
}
